// src/components/Header/Header.js
import styles from "./Header.module.css";
import Navigation from "../Navigation/Navigation";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <img src="/images/logo.png" alt="Teezash Logo" />
        <span> Teezash</span>
      </div>
      <Navigation />
    </header>
  );
};

export default Header;
